import { FC } from 'react';
import { Box, BoxProps, Flex, FormControl, FormLabel, Text } from '@chakra-ui/react';
import { ICON_BY_NAME } from '..';
import { CbFileUploadInput } from '..';
import { CbAvatar } from '../CbAvatar';
export interface CbFormikImageUploaderProps extends BoxProps {
  isManager?: boolean;
  image: string;
  placeholder?: string;
  isInvalid?: boolean;
  fieldId: string;
  fieldName: string;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void;
  values: any;
}
export const CbFormikImageUploader: FC<CbFormikImageUploaderProps> = ({
  isManager,
  image,
  onChange,
  isInvalid,
  fieldId,
  fieldName,
  setFieldValue,
  values,
  ...props
}) => {
  const activeStorageUploadComponent = () => {
    const maximumFileSize = 5 * 1024;
    return !values?.image ? <CbFileUploadInput accept="image/jpeg,image/png" label="Click to select a new profile image" maximumKilobytes={maximumFileSize} onUpload={({
      url,
      signed_blob_id
    }) => {
      setFieldValue('image', url);
      setFieldValue('blobId', signed_blob_id);
    }} data-sentry-element="CbFileUploadInput" data-sentry-component="activeStorageUploadComponent" data-sentry-source-file="CbFormikImageUploader.tsx" /> : <Flex alignItems={'flex-start'} flexDirection={'row'} data-sentry-element="Flex" data-sentry-component="activeStorageUploadComponent" data-sentry-source-file="CbFormikImageUploader.tsx">
        {/*className={styles.imagePreview}> */}
        <img src={values.image} />
        <Box cursor={'pointer'} marginLeft={1} onClick={() => {
        setFieldValue('image', '');
        setFieldValue('blobId', '');
      }} data-sentry-element="Box" data-sentry-source-file="CbFormikImageUploader.tsx">
          <ICON_BY_NAME.close data-sentry-element="unknown" data-sentry-source-file="CbFormikImageUploader.tsx" />
        </Box>
      </Flex>;
  };
  const managerDisclaimer = <Box {...props}>
      <Text>Learners can update their profile image from their profile</Text>
    </Box>;
  return <FormControl isInvalid={isInvalid} data-sentry-element="FormControl" data-sentry-component="CbFormikImageUploader" data-sentry-source-file="CbFormikImageUploader.tsx">
      <Box {...props} data-sentry-element="Box" data-sentry-source-file="CbFormikImageUploader.tsx">
        <FormLabel fontWeight="bold" color="text.secondary" htmlFor={fieldId} fontSize="md" data-sentry-element="FormLabel" data-sentry-source-file="CbFormikImageUploader.tsx">
          {fieldName}
        </FormLabel>
        <Flex alignItems="center" data-sentry-element="Flex" data-sentry-source-file="CbFormikImageUploader.tsx">
          {!values.image && <CbAvatar marginTop={2} marginRight={4} size="lg" image={image} />}
          {isManager ? managerDisclaimer : activeStorageUploadComponent()}
        </Flex>
      </Box>
    </FormControl>;
};